import { BigNumber as BigNumber_, Order } from '@blade/std-lib'

import type { Equivalence } from '@blade/std-lib'
import type { Network } from '@root/entities/network'
import type { PairAddress } from '@root/entities/pair'
import type BigNumber from 'bignumber.js'

export interface PriceInfo {
  /**
   * price in quote token
   */
  price: BigNumber
  priceNative: BigNumber
  priceUsd: BigNumber
  marketCap: BigNumber
}

export interface PnlInfo {
  pnlNative: BigNumber
  pnlUsd: BigNumber
  pnlPercent: number
}

export type PositionDetails = {
  pairAddress: PairAddress
  network: Network.Network
  hidden: boolean

  positionSizeUSD: BigNumber
  positionSizeNative: BigNumber
  positionSizeCurrency: BigNumber

  boughtSizeUSD: BigNumber
  boughtSizeNative: BigNumber
  boughtSizeCurrency: BigNumber
  boughtTransactions: number

  soldSizeUSD: BigNumber
  soldSizeNative: BigNumber
  soldSizeCurrency: BigNumber
  soldTransactions: number

  entryPrice: PriceInfo
  targetPrice: PriceInfo | undefined
  closePrice: PriceInfo | undefined

  createdAt: Date
  updatedAt: Date
  closedAt: Date | undefined

  pnl: PnlInfo
}

const sizeUsd = (position: PositionDetails) => position.positionSizeUSD
export const cmpSize = Order.mapInput(BigNumber_.order, sizeUsd)
export const cmpSizeDesc = Order.flip(cmpSize)

const updatedAt = (position: PositionDetails) => position.updatedAt
export const cmpUpdatedAt = Order.mapInput(Order.Date, updatedAt)
export const cmpUpdatedAtDesc = Order.flip(cmpUpdatedAt)

export const eqByPairAddress: Equivalence.Equivalence<PositionDetails> = (
  a: PositionDetails,
  b: PositionDetails,
) => a.pairAddress === b.pairAddress && a.network === b.network
